<template>
	<div class="contact-form">
		<h2 class="section-title-sm " v-if="formTitle">{{formTitle}}</h2>

		<p v-if="websiteId != 2" v-html="note" class=""></p>

		<theme-input
			label=""
			name="name"
			:placeholder="contactName"
			v-validate="`required|alpha_spaces_dash`"
		></theme-input>

		<theme-input
			label=""
			name="phone_number"
			type="tel"
			:placeholder="contactPhoneNumber"
			v-validate="`required|phone_number`"
		></theme-input>

		<theme-input
			label=""
			name="email"
			type="email"
			:placeholder="contactEmail"
			v-validate="`required|email`"
		></theme-input>

		<theme-textarea
			label=""
			name="message"
			:placeholder="contactMessage"
			v-validate="`required`"
		></theme-textarea>

		<v-recaptcha
			v-if="isRecaptcha === 'true'"
			@validate="checkRecaptcha"
			:site-key="recaptchaKey"
		></v-recaptcha>

		<button class="theme-btn theme-btn--block theme-btn--white" type="submit" @click.prevent="submitForm">
				{{buttonName}}
		</button>
	</div>
</template>

<script>
import VTextfieldPublic from "../admin/components/VTextfieldPublic.vue"
import sweetalert from "sweetalert";
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";

export default {
	inject: ['$validator'],
	components: {
		VTextfieldPublic
	},
	data () {
		return {
			recaptchaTicked: false
		}
	},
	computed: {
		...mapGetters(["locales"])
	},
	props: {
		buttonName: {
			default: 'Submit',
			type: String
		},
		buttonAlign: {
			default: 'left',
			type: String
		},
		showSuccess: {
			default: 1,
			type: Number
		},
		successText: {
			default: '',
			type: String
		},
		errorText: {
			default: '',
			type: String
		},
		isRecaptcha: {
			default: 'false',
			type: String
		},
		recaptchaMessage: {
			default: 'Please tick recaptcha',
			type: String
		},
		recaptchaKey: {
			default: '',
			type: String
		},
		formTitle: {
			default: '',
			type: String
		},
		contactName: {
			default: '',
			type: String
		},
		contactPhoneNumber: {
			default: '',
			type: String
		},
		contactEmail: {
			default: '',
			type: String
		},
		contactMessage: {
			default: '',
			type: String
		},
		note: {
			default: '',
			type: String
		},
		websiteId: {
			default: '',
			type: Number
		},
	},
	methods: {
		checkRecaptcha: function (result) {
			if (result === false) {
				this.recaptchaTicked = false;
			} else {
				this.recaptchaTicked = true;
			}
		},
		submitForm: function (e) {
			e.preventDefault();
			// console.log(e.target);
			$(e.target).prop('disabled', true);
			this.$validator.validateAll().then((res) => {
				if (this.isRecaptcha === 'true') {
					if (!this.recaptchaTicked) {
						sweetalert(window.app.locales.common.error, this.recaptchaMessage, 'error');
						$(e.target).prop('disabled', false);
						return;
					}
				}
				if (res) {
					let form = $('#form');
					let data = $('form').serialize();
					var message= this.successText;
					var errorMessage= this.errorText;
					if(this.showSuccess){
						$.ajax({
							url: form.attr('action'),
							method: 'post',
							data: data,
							success: function (result) {
								$(e.target).prop('disabled', false);
								if(result.url!==undefined){
									if(message!==''){
										sweetalert(window.app.locales.common.success,message, 'success').then((res) => {
											window.location.replace(result.url);
										});
									}else{
										sweetalert(window.app.locales.common.success,window.app.locales.subscriptions.successfully_added, 'success').then((res) => {
											window.location.replace(result.url);
										});
									}
								}
							},
							error: function(result){
								$(e.target).prop('disabled', false);
								if(result.responseJSON.url!==undefined){
									if(errorMessage!==''){
										sweetalert(window.app.locales.common.error,errorMessage, 'error').then((res) => {
											window.location.replace(result.responseJSON.url);
										});
									}else{
										sweetalert(window.app.locales.common.error,window.app.locales.common.error, 'error').then((res) => {
											window.location.replace(result.responseJSON.url);
										});
									}
								}
							}
						});
					}else{
						form.submit();
						$(e.target).prop('disabled', false);
					}
				} else {
					sweetalert(window.app.locales.common.error, window.app.locales.subscriptions.form_with_errors, 'error');
				}
			});
		}
	}
}
</script>
